import window from './window.js';

let analytics = function({
  category = '',
  action = '',
  label = '',
  value = 0,
}) {
  let data = {
    event: 'ga.event',
    eventCategory: category,
    eventAction: action,
    eventLabel: label,
    eventValue: value,
  };

  window.dataLayer.push(data);
};

export default analytics;
